<div class="eui-buttons-wrapper" [class.eui-buttons-wrapper--mobile]="(asService.breakpoints$ | async).isMobile || (asService.breakpoints$ | async).isTablet">
    <div class="eui-buttons__actions-container">
        <!-- ACTION BUTTONS -->
        <ng-container *ngIf="!((asService.breakpoints$ | async).isMobile || (asService.breakpoints$ | async).isTablet)">
            <ng-container *ngTemplateOutlet="actionsButtons"></ng-container>
        </ng-container>

        <!-- BOOKMARK BUTTON -->
        <button *ngIf="isBookmarkable && !((asService.breakpoints$ | async).isMobile || (asService.breakpoints$ | async).isTablet)"
                euiButton euiOutline euiSecondary
                [title]="isBookmarked ? ('eui.pageHeader.REMOVE-BOOKMARK.tooltip' | translate) : ('eui.pageHeader.ADD-BOOKMARK.tooltip' | translate )"
                [attr.aria-label]="isBookmarked ? ('eui.pageHeader.REMOVE-BOOKMARK.tooltip' | translate) : ('eui.pageHeader.ADD-BOOKMARK.tooltip' | translate )"
                (click)="onBookmarkToggle($event)">
            <span euiIcon [iconClass]="isBookmarked ? 'eui-icon eui-icon-bookmark' : 'eui-icon eui-icon-bookmark-o'"></span>
            <span *ngIf="isBookmarked">{{ 'eui.pageHeader.REMOVE-BOOKMARK' | translate }}</span>
            <span *ngIf="!isBookmarked">{{ 'eui.pageHeader.ADD-BOOKMARK' | translate }}</span>
        </button>

        <!-- LOCAL MENU WHEN IN MOBILE/TABLET MODE -->
        <div *ngIf="hasLocalMenu || ( (asService.breakpoints$ | async).isMobile || (asService.breakpoints$ | async).isTablet )"
             class="eui-buttons__local-menu"
             [class.eui-buttons__local-menu--mobile]="(asService.breakpoints$ | async).isMobile || (asService.breakpoints$ | async).isTablet"
             euiSizeS>
            <eui-dropdown>
                <button euiButton euiPrimary [euiOutline]="localMenuLabel" [euiBasicButton]="!localMenuLabel" [euiRounded]="!localMenuLabel" [euiIconButton]="!localMenuLabel">
                    <span *ngIf="localMenuLabel" euiLabel>{{localMenuLabel}}</span>
                    <span euiIcon iconClass="eui-icon-more-vertical"></span>
                </button>
                <eui-dropdown-content>
                    <!-- Action buttons -->
                    <ng-container *ngIf="customActionsContent && ((asService.breakpoints$ | async).isMobile || (asService.breakpoints$ | async).isTablet)">
                        <ng-container *ngTemplateOutlet="actionsButtons"></ng-container>
                    </ng-container>

                    <!-- Local menu items -->
                    <ng-container *ngIf="hasLocalMenu && (customLocalMenuContent && customLocalMenuContent.length !== 0)">
                        <ng-container *ngTemplateOutlet="localMenu"></ng-container>
                    </ng-container>

                    <!-- Extra menu items -->
                    <ul euiList class="eui-buttons__local-menu-extras">
                        <li *ngIf="isBookmarkable && ((asService.breakpoints$ | async).isMobile || (asService.breakpoints$ | async).isTablet)" euiListItem
                            [title]="isBookmarked ? ('eui.pageHeader.REMOVE-BOOKMARK-TOOLTIP' | translate) : ('eui.pageHeader.ADD-BOOKMARK-TOOLTIP' | translate )"
                            [attr.aria-label]="isBookmarked ? ('eui.pageHeader.REMOVE-BOOKMARK-TOOLTIP' | translate) : ('eui.pageHeader.ADD-BOOKMARK-TOOLTIP' | translate )"
                            (click)="onBookmarkToggle($event)">
                            <span euiIcon euiSize2XL [iconClass]="isBookmarked ? 'eui-icon eui-icon-bookmark' : 'eui-icon eui-icon-bookmark-o'" class="eui-u-color-info"></span>
                            <span *ngIf="isBookmarked" euiLabel>{{ 'eui.pageHeader.REMOVE-BOOKMARK' | translate }}</span>
                            <span *ngIf="!isBookmarked" euiLabel>{{ 'eui.pageHeader.ADD-BOOKMARK' | translate }}</span>
                        </li>
                        <li *ngIf="isPrintable" euiListItem (click)="onPrint($event)">
                            <span euiIcon euiSize2XL iconClass="eui-icon-print" class="eui-u-color-info"></span>
                            <span euiLabel class="eui-u-color-info">Print</span>
                        </li>
                    </ul>
                </eui-dropdown-content>
            </eui-dropdown>
        </div>
    </div>
</div>

<ng-template #actionsButtons>
    <div class="eui-buttons__actions-content" [class.eui-buttons__actions-content--mobile]="(asService.breakpoints$ | async).isMobile || (asService.breakpoints$ | async).isTablet">
        <ng-content select="euiButtonsActionsContent"></ng-content>
    </div>
</ng-template>

<ng-template #localMenu>
    <div class="eui-buttons__local-menu-content" [class.eui-buttons__local-menu-content--mobile]="(asService.breakpoints$ | async).isMobile || (asService.breakpoints$ | async).isTablet">
        <ng-content select="euiButtonsLocalMenuContent"></ng-content>
    </div>
</ng-template>
